import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {useFormik} from "formik";
import * as Yup from 'yup';
import {
    getUserLinkedinData,
    vendorClientReviewCheckToken,
    vendorClientReviewSubmit
} from "../../../../services/api/public";
import ReviewSubmitSuccess from "./SubmitReviewSuccess";
import SubmitReviewStep1 from "../../../../components/ClientReviews/Step1";
import SubmitReviewStep2 from "../../../../components/ClientReviews/Step2";

const CDN = process.env.REACT_APP_RESIZABLE;

const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
const redirectUrl = `${window.location.origin}/public/marketing/leave-review`;

const SubmitReviewModal = () => {

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const code = params.get('code');

    const {token} = useParams();

    const [activeStep, setActiveStep] = useState(1);
    const [vendorData, setVendorData] = useState(null);
    const [linkedinCode, setLinkedinCode] = useState(null);
    const [linkedinData, setLnkedinData] = useState(null);

    const ReviewSchema = [
        Yup.object().shape({
            name: Yup.string().required('This field is required.').max(192, 'Max 192 characters'),
            email_address: Yup.string().email('This field is required.').required('This field is required.').max(100, 'Max 100 characters'),
            overall_rating: Yup.number().required('We need this information. Please choose.'),
            company_name: Yup.string().nullable().max(100, 'Max 100 characters'),
        }),
        Yup.object().shape({})
    ];


    const formik = useFormik({
        initialValues: {
            token: token,
            name: '',
            email_address: '',
            type: 1,
            company_name: '',
            overall_rating: null,
            comment: '',
            changes: '',
            li_photo: ""

        },
        validationSchema: ReviewSchema[activeStep - 1],
        onSubmit: async (values) => {
            if (activeStep === 1) {
                setActiveStep(activeStep + 1);
                return
            }

            try {
                const res = await vendorClientReviewSubmit(values);
                localStorage.removeItem('userToken');
                removeLinkedinData();
                if (res)
                    setActiveStep(3);
            } catch (e) {
                removeLinkedinData();
                localStorage.removeItem('userToken');
            }
        },
    });


    const checkToken = async (userToken = token) => {
        try {
            const data = await vendorClientReviewCheckToken(userToken);
            if (!data)
                setVendorData({valid: false})
            else {
                setVendorData(data.data)
            }
        } catch (e) {

        }
    }

    const getLinkedinData = async () => {
        try {
            const res = await getUserLinkedinData(linkedinCode, redirectUrl);
            setLnkedinData(res);
        } catch (e) {
        }

    }

    const removeLinkedinData = () => {
        localStorage.removeItem('li_photo');
        localStorage.removeItem('name');
        localStorage.removeItem('email_address');
    }

    useEffect(() => {
            if (token) {
                localStorage.setItem('userToken', token);
                checkToken().catch(e => {

                });
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [token]);

    useEffect(() => {
            if (code) {
                const userToken = localStorage.getItem('userToken');
                checkToken(userToken).catch(e => {
                });
                setLinkedinCode(code);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [code]);

    useEffect(() => {
            if (linkedinCode)
                getLinkedinData().catch(e => {

                });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [linkedinCode]);

    useEffect(() => {
            if (linkedinData) {
                const userToken = localStorage.getItem('userToken');
                formik.setFieldValue('li_photo', linkedinData.picture)
                formik.setFieldValue('token', userToken)

                formik.handleChange({
                    target: {name: 'name', value: linkedinData.name}
                })
                formik.handleChange({
                    target: {name: 'email_address', value: linkedinData.email}
                });

                localStorage.setItem('li_photo', linkedinData.picture);
                localStorage.setItem('name', linkedinData.name);
                localStorage.setItem('email_address', linkedinData.email);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [linkedinData]
    );

    useEffect(() => {

            if (localStorage.getItem('name')) {
                formik.setFieldValue('token', localStorage.getItem('userToken'))

                formik.setFieldValue('li_photo', localStorage.getItem('li_photo'))

                formik.handleChange({
                    target: {name: 'name', value: localStorage.getItem('name')}
                })
                formik.handleChange({
                    target: {name: 'email_address', value: localStorage.getItem('email_address')}
                });
            }

        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [])

    if (!code) {
        removeLinkedinData();
        window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&state=DCEeFWf45A53sdfKef424&scope=openid%20profile%20email`
        return;
    }

    if (!vendorData)
        return;

    if (!vendorData.valid)
        return <div>Token not valid</div>


    if (activeStep === 3)
        return <ReviewSubmitSuccess/>


    return (
        <div>
            <main className="sl-main sl-mt-8">
                <div className="sl-container sl-m-auto sl-my-8 sl-bg-white sl-shadow-sm sl-border-radius-8
                sl-pt-8 sl-pl-40 sl-pr-40 sl-pb-8  sl-display-flex sl-flex-col sl-max-w-252
                ">
                    <div className="sl-display-flex sl-gap-12 sl-mb-12">
                        <div
                            className="sl-display-flex sl-flex-row sl-gap-5">

                            <div className="sl-border-2 sl-border-radius-8"
                            >
                                <img

                                    alt={vendorData.company.name}
                                    src={`${CDN}/${vendorData.company.logo}`}
                                    className="sl-w-48 sl-h-24 sl-border-1 sl-border-solid sl-border-radius-8 sl-border-gray-200"
                                    style={{objectFit: 'scale-down'}}
                                />
                            </div>

                            <div className="sl-text-left sl-m-auto">
                                <h2 className="sl-pt-0 sl-pb-1 sl-m-0 sl-font sl-font-bold sl-text-xxl sl-text-gray-900 sl-font">Leave
                                    a review for {vendorData.company.name}</h2>
                                <span className="sl-font sl-font-medium sl-text-sm sl-text-gray-700 sl-font">Share your experience! Leave a review and help others make informed
                                    decisions.<br/> It
                                    only
                                    takes a minute!</span>

                            </div>
                        </div>
                    </div>

                    <div style={{display: activeStep === 1 ? "block" : "none"}}><SubmitReviewStep1 formik={formik}
                                                                                                   vendorData={vendorData}/>
                    </div>
                    <div style={{display: activeStep === 2 ? "block" : "none"}}><SubmitReviewStep2 formik={formik}
                                                                                                   vendorData={vendorData}/>
                    </div>

                    <div
                        className={`sl-modal-footer sl-py-32 sl-display-flex sl-flex-row ${activeStep === 2 ? 'sl-justify-space-between' : 'sl-justify-end'} `}>
                        {activeStep === 2 && <div
                            className="sl-flex sl-justify-end sl-gap-2-point-5
                             sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal

                             ">
                            <button
                                onClick={() => setActiveStep(activeStep - 1)}
                                className="sl-btn sl-btn-tertiary sl-btn-lg  sl-rounded-lg sl-text-md sl-pl-20 sl-pr-20 sl-font">
                                Back
                            </button>
                        </div>}

                        <div
                            className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                            <button
                                onClick={formik.submitForm}
                                className="sl-btn sl-btn-primary sl-btn-lg  sl-rounded-lg sl-text-md sl-pl-20 sl-pr-20 sl-font ">
                                {formik.isSubmitting &&
                                <div
                                    className="sl-loader sl-m-auto sl-w-6 sl-h-6 "/>}
                                {!formik.isSubmitting && activeStep === 1 && 'Next'}
                                {!formik.isSubmitting && activeStep === 2 && 'Submit'}
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )

}

export default SubmitReviewModal;